// Standalone Heading
interface Props {
	slice: any
}

export default function Heading({ slice }: Props) {
	const { primary } = slice

	return (
		<header className="heading section pb-0">
			<div className="container text-center space-y-4">
				{/* Subhead */}
				{primary.section_lead_title && <p className="font-medium">{primary.section_lead_title}</p>}

				{/* Title */}
				{primary.section_title?.[0] && (
					<h2 className="title text-4xl">{primary.section_title[0].text}</h2>
				)}
				{/* <pre>{JSON.stringify(slice, null, 2)}</pre> */}
			</div>
		</header>
	)
}
